import type { ValueTypeEntry } from "../index";
import { NumberEditor, type NumberValue } from "./number-editor";

const numberFormatter = new Intl.NumberFormat("en-US");

function formatNumber(value: NumberValue): string {
  if (value === null || value === undefined) return "";
  if (typeof value !== "number" || !Number.isFinite(value)) return "";
  return numberFormatter.format(value);
}

/**
 * Built-in `number` field type. Format uses `Intl.NumberFormat("en-US")`
 * and emits "" for null/NaN/non-finite. The editor is a controlled
 * `<input type="number">` that commits on Enter / blur, cancels on Escape,
 * commits null when empty, and refuses to commit NaN.
 */
export const numberType: ValueTypeEntry<NumberValue> = {
  name: "number",
  format(value) {
    return formatNumber(value);
  },
  render({ value }) {
    return formatNumber(value);
  },
  display({ value }) {
    const narrowed = typeof value === "number" ? value : null;
    return formatNumber(narrowed);
  },
  edit({ value, onCommit, onCancel }) {
    return <NumberEditor value={value} onCommit={onCommit} onCancel={onCancel} />;
  },
};
